<template>
  <cus-dialog>
    <template v-slot:title>
      <div class="scan-button">
        <cus-button text="掃描電子券" color="blue" style="min-height: 45px" @click="openTicketScan"></cus-button>
      </div>
      <p class="dialog-title">電子券</p>
    </template>
    <template v-slot:body>
      <div class="event-list">
        <div class="event-type">
          <p
            :class="[selectType === 'voucher' ? 'select' : '',  (getVoucherList?.length > 0 || 'disable')]"
            @click="handleChangeType('voucher', getVoucherList?.length)"
          >
            商品券({{ getVoucherList?.length || 0 }})
          </p>
          <p
            :class="[selectType === 'coupon' ? 'select' : '', getCouponList?.length  || 'disable']"
            @click="handleChangeType('coupon', getCouponList?.length)"
          >
            優惠券({{ getCouponList?.length || 0 }})
          </p>
        </div>
        <div class="table">
          <div class="table-head">
            <p>名稱</p>
            <p>適用時間</p>
          </div>
          <div class="h-100" :style="`display: grid; grid-template-rows: repeat(${pageItem}, ${100 / pageItem}%)`">
            <div
              :class="['table-item', selectItem === item[parameter[selectType].id] ? 'table-item-selected' : '']"
              v-for="(item, index) in renderList"
              :key="index"
              @click="handleClickItem(item, $event)"
            >
              <div>
                <p>{{ index + 1 + (currentPage - 1) * pageItem }}. {{ item[parameter[selectType].name] }}</p>
                <p>
                  {{ formatDateTime('YYYY/MM/DD HH:mm', item.start_date) }} ~
                  {{ formatDateTime('YYYY/MM/DD HH:mm', item.end_date) }}
                </p>
                <div class="use-button">
                  <cus-button
                    v-if="checkUsed(item[parameter[selectType].id])"
                    text="已使用"
                    color="green"
                    fontSize="normal"
                    style="padding: 0; min-height: auto"
                    :disabled="true"
                  ></cus-button>
                  <cus-button
                    v-else-if="selectItem === item[parameter[selectType].id]"
                    text="使用電子券"
                    color="green"
                    fontSize="normal"
                    style="padding: 0; min-height: auto"
                    @click="handleUseTicket(item)"
                  ></cus-button>
                </div>
              </div>
            </div>
          </div>
          <cus-page :totalPage="totalPage" v-model:currentPage="currentPage"></cus-page>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="關閉" color="white" style="padding: 0" @click="close()"></cus-button>
      </div>
    </template>
  </cus-dialog>
</template>
<script>
import { ref, computed, watch, inject, getCurrentInstance } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { formatDateTime } from '@/utils/datetime';
import {useStore} from "vuex";
export default {
  name: 'ticket-list',
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    //取得provide參數
    const close = inject('close');
    const openDialog = inject('openDialog');
    //取得清單
    const { getVoucherList, getCouponList } = useGetters('member', ['getVoucherList', 'getCouponList']);
    const ticketList = computed(() => {
      if (selectType.value === 'voucher') return getVoucherList.value;
      else return getCouponList.value;
    });
    //設定參數
    const parameter = {
      voucher: {
        name: 'buy_drink_name',
        id: 'voucher_id',
      },
      coupon: {
        name: 'title',
        id: 'coupon_id',
      },
    };
    const hasValidPhoneNumber = computed(() => {
      const phone = store.getters['member/getMemberPhone'];
      return phone && phone.length > 5;
    });

    const selectType = ref(hasValidPhoneNumber.value ? 'coupon' : (getVoucherList.value?.length > 0 ? 'voucher' : 'coupon'));
    const selectItem = ref(null);
    const currentPage = ref(1);
    //處理分頁品項
    const pageItem = ref(10);
    const totalPage = computed(() => Math.ceil(ticketList.value?.length / pageItem.value));
    const renderList = computed(() =>
      ticketList.value?.slice((currentPage.value - 1) * pageItem.value, currentPage.value * pageItem.value)
    );
    //切換類型
    const handleChangeType = (type, count) => {
      if (!count) return;
      selectType.value = type;
      selectItem.value = null;
      currentPage.value = 1;
    };
    //換頁歸零
    watch(currentPage, () => {
      if (selectItem.value !== null) {
        selectItem.value = null;
      }
    });
    //檢查有沒有使用
    const getCart = useGetters('cart', ['getCart']);
    const checkUsed = (code) => {
      return getCart.value.some((e) => e.form_source_code === code);
    };
    //點擊
    const handleClickItem = (item, e) => {
      if (e.target.getAttribute('data-name') === 'cus-button') return;
      if (selectItem.value === item[parameter[selectType.value].id]) {
        selectItem.value = null;
      } else {
        selectItem.value = item[parameter[selectType.value].id];
      }
    };
    //使用電子券
    const doRedeemTicket = useActions('member', ['doRedeemTicket']);

    const handleUseTicket = (item) => {

      //判斷是不是電話會員
      const cell_phone = store.getters['member/getMemberPhone'];
      if (cell_phone && cell_phone.length > 5 && selectType.value === 'voucher') {
        proxy
            .$message('提醒', `電話會員不能使用商品券`, {
              image: require('@/assets/images/icon-notice.png'),
              confirmText: '確定',
            });
        return;
      }


      proxy
        .$confirm({
          content: `${cell_phone}是否確定要使用「${item[parameter[selectType.value].name]}」？`,
        })
        .then(async () => {
          await doRedeemTicket({
            ticket_type: selectType.value,
            ticket_id: item[parameter[selectType.value].id],
          });
          close();
        })
        .catch((e) => e);
    };
    //掃描電子券
    const doQueryTicket = useActions('member', ['doQueryTicket']);
    const openTicketScan = async () => {
      try {
        openDialog('noticeScan', { scanType: 6 }, { dialogContent: `請感應/掃描電子券` });
        await doQueryTicket();
        close();
      } catch (error) {
        close();
      }
    };
    return {
      formatDateTime,
      close,
      getVoucherList,
      getCouponList,
      parameter,
      selectType,
      selectItem,
      currentPage,
      pageItem,
      totalPage,
      renderList,
      handleChangeType,
      checkUsed,
      handleClickItem,
      handleUseTicket,
      openTicketScan,
      hasValidPhoneNumber,
    };
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  text-align: center;
  font-size: 2.4rem;
  line-height: 60px;
  color: $color-blue;
}
.scan-button {
  width: 140px;
  position: absolute;
  top: 16px;
  left: 16px;
}
$bar-height: 6vh;
.event-list {
  padding: 20px 0 0;
  display: grid;
  grid-template-rows: $bar-height auto;
  grid-gap: 8px;
}

.event-type {
  width: 100%;
  background-color: $color-gray-6;
  border-radius: 27px;
  text-align: center;
  font-size: 2.2rem;
  color: $color-blue;
  display: grid;
  grid-template-columns: 50% 50%;
  p {
    line-height: $bar-height;
    transition: 0.2s;
    border-radius: 27px;
    cursor: pointer;
  }
  p.select {
    background-color: $color-blue;
    color: #fff;
  }
  p.disable {
    opacity: 0.5;
  }
}

.table {
  display: grid;
  grid-template-rows: 44px auto 55px;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
  font-size: 1.8rem;
  @mixin table-rows-grid {
    display: grid;
    grid-template-columns: minmax(0, 45%) 35% auto;
    align-items: center;
    height: 100%;
  }
  &-head {
    @include table-rows-grid;
    padding: 0 15px;
    border-bottom: 2px solid $color-gray-10;
    height: 100%;
    background-color: $color-gray-3;
  }
  &-item {
    padding: 0 15px;
    cursor: pointer;
  }
  &-item > div {
    @include table-rows-grid;
    border-bottom: 1px solid $color-gray-10;
  }
  &-item > div > p {
    width: 100%;
    font-weight: 500;
    color: $color-blue;
    font-size: 2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  //選中樣式
  &-item-selected {
    background-color: $color-blue;
    color: #fff;
    p {
      color: #fff !important;
    }
  }
  &-item-selected > div {
    border-bottom: transparent;
  }
  .use-button {
    width: 100px;
    margin-left: auto;
  }
}
</style>
